import { render, staticRenderFns } from "./Winecard.vue?vue&type=template&id=8bf8d530&"
import script from "./Winecard.vue?vue&type=script&lang=js&"
export * from "./Winecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports